import {
  fetchPlatinumPriceEUR,
  fetchPlatinumPriceUSD,
} from "./api/metals/PlatinoApi.js";

let platinumPriceCache = {
  usd: null,
  eur: null,
  usdPerGram: null,
  eurPerGram: null,
  lastUpdate: 0,
  date: null,
  source: null,
};

const CACHE_DURATION = 10 * 60 * 1000;
const OUNCE_TO_GRAMS = 31.1034768;

/**
 * Obtiene el precio del platino en USD y EUR (gold-api.com / API Platino).
 */
export const getPlatinumPrice = async (forceRefresh = false) => {
  const now = Date.now();

  if (!forceRefresh && platinumPriceCache.usd) {
    const cacheAge = now - platinumPriceCache.lastUpdate;
    if (cacheAge < CACHE_DURATION) {
      return {
        usd: platinumPriceCache.usd,
        eur: platinumPriceCache.eur,
        usdPerGram: platinumPriceCache.usdPerGram,
        eurPerGram: platinumPriceCache.eurPerGram,
        timestamp: new Date(platinumPriceCache.lastUpdate),
        date: platinumPriceCache.date,
        source: platinumPriceCache.source,
        fromCache: true,
      };
    }
  }

  try {
    const [usdData, eurData] = await Promise.all([
      fetchPlatinumPriceUSD(),
      fetchPlatinumPriceEUR(),
    ]);

    const usdPrice = usdData.price;
    const eurPrice = eurData.price;
    const date = usdData.updatedAt || eurData.updatedAt;
    const usdPerGram = usdPrice / OUNCE_TO_GRAMS;
    const eurPerGram = eurPrice / OUNCE_TO_GRAMS;

    platinumPriceCache = {
      usd: usdPrice,
      eur: eurPrice,
      usdPerGram,
      eurPerGram,
      lastUpdate: now,
      date,
      source: "gold-api.com",
    };

    return {
      usd: usdPrice,
      eur: eurPrice,
      usdPerGram,
      eurPerGram,
      timestamp: new Date(now),
      date,
      fromCache: false,
      source: "gold-api.com",
    };
  } catch (error) {
    console.error("Error obteniendo precio del platino:", error);

    if (platinumPriceCache.usd) {
      return {
        usd: platinumPriceCache.usd,
        eur: platinumPriceCache.eur,
        usdPerGram: platinumPriceCache.usdPerGram,
        eurPerGram: platinumPriceCache.eurPerGram,
        timestamp: new Date(platinumPriceCache.lastUpdate),
        date: platinumPriceCache.date,
        source: platinumPriceCache.source,
        fromCache: true,
        error: error.message,
      };
    }

    throw error;
  }
};

export const getPlatinumPricePerGramEUR = async (forceRefresh = false) => {
  const data = await getPlatinumPrice(forceRefresh);
  return data.eurPerGram;
};
